export enum Unity4Claim {
  EmpathyAccess = 'empathy-access',
  AdminModule = 'admin-module',
  CampaignCoreAutoschedulenow = 'campaign-core-autoschedulenow',
  CampaignCoreRead = 'campaign-core-read',
  CampaignCoreUpdate = 'campaign-core-update',
  CampaignCreate = 'campaign-create',
  CampaignModule = 'campaign-module',
  ChatModule = 'chat-module',
  ClaimCreate = 'claim-create',
  ClaimModule = 'claim-module',
  ClaimRead = 'claim-read',
  ClaimUpdate = 'claim-update',
  ComposerModule = 'composer-module',
  ComposerEditingBasic = 'composer-editing-basic',
  ComposerEditingAdvanced = 'composer-editing-advanced',
  EmpathyTrainingModule = 'training-module',
  HrModule = 'hr-module',
  HousingModule = 'housing-module',
  MessagesModule = 'messages-module',
  RecordingsModule = 'recordings-module',
  RecordsModule = 'records-module',
  ReportadminModule = 'reportadmin-module',
  ReportadminPermissionUpdate = 'reportadmin-permission-update',
  ReportsClientReporting = 'reports-client-reporting',
  ReportsModule = 'reports-module',
  RoutePointPopout = 'route-point-popout',
  SupportCreate = 'support-create',
  SupportModule = 'support-module',
  SupportUpdate = 'support-update',
  SupportView = 'support-view',
  SurveyManager = 'survey-manager',
  TenantCoreRead = 'tenant-core-read',
  TenantCoreUpdate = 'tenant-core-update',
  TenantCreate = 'tenant-create',
  TenantModule = 'tenant-module',
  TooltipsModule = 'tooltips-module',
  UserCoreRead = 'user-core-read',
  UserCoreUpdate = 'user-core-update',
  UserCreate = 'user-create',
  UserModule = 'user-module',

  TeleworkerAccess = 'teleworker-access',
  AccountDetails = 'account-details',
  AddressLookup = 'address-lookup',
  AgentReportsModule = 'teleworker-reports-module',
  CampaignAgreement = 'teleworker-campaign-agreement',
  ChatSupervisor = 'chat-supervisor',
  ClickToCall = 'click-to-call',
  ConnectSelectUser = 'connect-reports-selectuser',
  ContactDetailsModule = 'contact-details-module',
  DialButton = 'dial-button',
  EmergencyContact = 'emergency-contact',
  NewsModule = 'news-module',
  IBTransferOnly = 'ib-transfer-only',
  OmniChannel = 'omni-channel',
  TestingModule = 'testing-module',
  TimesheetsModule = 'timesheets-module',
  TrainingModule = 'teleworker-training-module',
  TrainingRoomLinks = 'teleworker-training-links',
  WorkModule = 'gotowork-module',
  WorkViaAvailabilityModule = 'gotoworkviaavailability-module',

  MultiFactorAuth = 'multi-factor-auth',
  IPRestrictionExemption = 'ip-restriction-exemption',
  IdleCheck = 'idle-check',
  ScheduleCheck = 'schedule-check',
  MinimumAvailability = 'minimum-availability',
  RequestLogging = 'request-logging',
  UseSignalrSubmit = 'use-signalr-submit',
  Base64EncodeRecord = 'base64-encode-record',
  UseUkVOIPFromSiddle = 'use-uk-voip-siddle',
  VerboseLogging = 'verbose-logging',
}

const Unity4Claims = Object.values(Unity4Claim);
export function isClaim(claim: string): boolean {
  return Unity4Claims.includes(claim as Unity4Claim);
}
